<template>
    <div class="user-origin">
        <Card size="small">
            <header>
                <div class="name">{{ $t('venue_statistics.user_origin.headline') }}</div>
                <Select v-model="select" :options="options"></Select>
            </header>
            <div v-if="showEmptyState" class="empty-state">
                <p>
                    {{ $t('venue_statistics.user_origin.empty_state') }}
                </p>
            </div>
            <div v-if="venueAnalytics" class="chart-content">
                <div
                    v-for="origin in venueAnalytics.visitors.originDistribution.slice(0, 3)"
                    :key="origin.city"
                    class="origin-distribution"
                >
                    <div class="city">{{ origin.city }}</div>
                    <div class="occurrence">{{ occurrenceFormatted(origin.occurrence) }}</div>
                </div>
            </div>
        </Card>
    </div>
</template>

<script>
import Card from '@/components/Card'
import Select from '@/components/Select'
import { Chart, registerables } from 'chart.js'
import gql from 'graphql-tag'
Chart.register(...registerables)

export default {
    name: 'UserGender',
    components: {
        Card,
        Select,
    },
    props: {
        venueAnalytics: {
            type: Object,
            default: undefined,
        },
        historicalData: {
            type: Boolean,
            default: false,
        },
    },
    apollo: {
        venue: {
            query: gql`
                query ($id: ID!) {
                    venue(id: $id) {
                        id
                        capacity
                    }
                }
            `,
            variables() {
                return {
                    id: this.$route.params.id,
                }
            },
            result() {},
        },
    },
    data() {
        return {
            options: [
                { value: 'percent', text: '%' },
                { value: 'sum', text: 'Sum' },
            ],
            select: 'sum',
        }
    },
    computed: {
        showEmptyState() {
            if (this.historicalData) {
                return false
            } else if (
                this.venueAnalytics &&
                this.venueAnalytics.visitors &&
                this.venueAnalytics.visitors.new +
                    this.venueAnalytics.visitors.recurring +
                    this.venueAnalytics.visitors.vip >
                    0
            ) {
                return false
            } else {
                return true
            }
        },
    },
    methods: {
        occurrenceFormatted(occurrence) {
            if (this.select === 'percent') {
                const cV = this.venueAnalytics.visitors
                const total = cV.new + cV.recurring + cV.vip
                return `${Math.round((occurrence / total) * 100)} %`
            }

            return occurrence
        },
    },
}
</script>

<style scoped lang="sass">
.user-origin
    max-width: 100vw
    width: 100%
    box-sizing: border-box

    .empty-state
        display: flex
        justify-content: center
        align-items: center
        height: 100px
        text-align: center
        user-select: none


    .card
        min-height: 229px
        box-sizing: border-box
        background: #ffffff !important
        padding-bottom: 0

    header
        display: flex
        justify-content: space-between
        margin-bottom: $s

        .d-select
            min-width: 80px

        .name
            color: $neutral-black
            font-weight: 600
            padding: $xs
            font-size: 14px
            line-height: 17px

    .origin-distribution
        padding: $m
        border-top: 1px solid rgba(231, 233, 237, 1)
        display: flex
        justify-content: space-between

        .city, .occurrence
            font-size: 14px
            line-height: 17px
</style>
